import React from "react";
import TableData from "./Table/TableData";
import ReturntoSupplierData from "./Table/ReturntoSupplierdata";
import DeliveryModal from "./DeliveryModal";
export default function GoodsoutCard() {
  return (
    <div>
      <div class="flex flex-wrap ">
        <div class="w-full md:overflow-x-auto sm:overflow-x-auto ">
          <div className="flex flex-wrap "></div>
          <div
            className=" overflow-auto"
            // "w-[calc(100vw_-_12rem)]"
          >
            <DeliveryModal />
          </div>
        </div>
      </div>
      <div class="flex flex-wrap justify-center">
          <div
            className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
            // "w-[calc(100vw_-_12rem)]"
          >
            <TableData />
        </div>
      </div>
      <div class="flex flex-wrap justify-center mt-8">
          <div
            className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
            // "w-[calc(100vw_-_12rem)]"
          >
            <ReturntoSupplierData />
          </div>
      </div>
    </div>
  );
}
